import { type ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';

import { getUserFullName } from '@/services/helpers/strings';
import type { KeysToCamelCase } from '@/types/app';
import type { TOnlineRequestStatus } from '@/types/request';

export interface HistoryDataSourceInterface {
  comment: string;
  date: string;
  id: string;
  initiator: string;
}

export const historyTableDataSource: ColumnsType<HistoryDataSourceInterface> = [
  {
    title: 'Комментарий',
    dataIndex: 'comment',
    key: 'comment',
    width: 480,
    render: (_, record) => (
      <span className="order-history__cell-text">{record.comment}</span>
    )
  },
  {
    title: 'Дата',
    dataIndex: 'date',
    key: 'date',
    sorter: (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    render: (_, record) => (
      <span className="order-history__cell-text">
        {dayjs(record.date).format('DD.MM.YYYY, HH:mm:ss')}
      </span>
    )
  },
  {
    title: 'Инициатор',
    dataIndex: 'initiator',
    key: 'initiator',
    sorter: (a, b) => a.initiator.localeCompare(b.initiator),
    render: (_, record) => (
      <span className="order-history__cell-text">{record.initiator}</span>
    )
  }
];

export const onlineHistoryTableDataSource: ColumnsType<
  KeysToCamelCase<TOnlineRequestStatus>
> = [
  {
    title: 'Пользователь',
    dataIndex: 'user',
    key: 'user',
    render: (_, record) => (
      <span className="order-history__cell-text">
        {getUserFullName(record.user, {
          pattern: 'first_last'
        })}
      </span>
    )
  },
  {
    title: 'Новый статус',
    dataIndex: 'status',
    key: 'status',
    sorter: (a, b) => {
      const aStatus = a.toFcStatus?.name || '';
      const bStatus = b.toFcStatus?.name || '';
      return aStatus.localeCompare(bStatus);
    },
    render: (_, record) => (
      <span className="order-history__cell-text">
        {record.toFcStatus?.name}
      </span>
    )
  },
  {
    title: 'Комментарий',
    dataIndex: 'comment',
    key: 'comment',
    render: (_, record) => (
      <span className="order-history__cell-text order-history__cell-text--comment">
        {record.comment}
      </span>
    )
  },
  {
    title: 'Дата',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    render: (_, record) => (
      <span className="order-history__cell-text">
        {dayjs(record.createdAt).format('DD.MM.YYYY, HH:mm:ss')}
      </span>
    )
  }
];
